module.exports = __webpack_public_path__ + "img/project-adaptive-1.jpg?8acafc74dff6bd742c07d12730e00af8";